import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "absolute w-80 p-4 rounded-lg bg-white z-10 shadow-secondary" }
const _hoisted_3 = { class: "tooltip-content" }

import { ref } from "vue";

interface PropsI {
  tooltipText: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTooltip',
  props: {
    tooltipText: {}
  },
  setup(__props: any) {

const props = __props;



const isTooltipTextVisible = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isTooltipTextVisible.value = true)),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isTooltipTextVisible.value = false))
    }, [
      _renderSlot(_ctx.$slots, "icon")
    ], 32),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(props.tooltipText), 1)
    ], 512), [
      [_vShow, isTooltipTextVisible.value]
    ])
  ]))
}
}

})